var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimesCircle = function SvgTimesCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C7.385 0 0 7.385 0 16.5S7.385 33 16.5 33 33 25.615 33 16.5 25.615 0 16.5 0Zm0 29.806c-7.352 0-13.306-5.954-13.306-13.306 0-7.352 5.954-13.306 13.306-13.306 7.352 0 13.306 5.954 13.306 13.306 0 7.352-5.954 13.306-13.306 13.306Zm6.773-17.444L19.135 16.5l4.138 4.138a.8.8 0 0 1 0 1.131l-1.504 1.504a.8.8 0 0 1-1.13 0L16.5 19.135l-4.138 4.138a.8.8 0 0 1-1.131 0l-1.504-1.504a.8.8 0 0 1 0-1.13l4.138-4.139-4.138-4.138a.8.8 0 0 1 0-1.131l1.504-1.504a.8.8 0 0 1 1.13 0l4.139 4.138 4.138-4.138a.8.8 0 0 1 1.131 0l1.504 1.504a.8.8 0 0 1 0 1.13Z",
    fill: "#D7D9DB",
    fillOpacity: 0.8
  })));
};
export default SvgTimesCircle;